module.exports = __webpack_public_path__ + "media/assets/illustrations/tip-light-bulb-on-3fe56772367183d6e075f447ffc340de.png";